import { Box } from '@chakra-ui/react';
import React from 'react';
import { AmplifyCore } from '@codametrix/ui-common';
import { styleOverrides, styles } from './service-desk.styles';
import { getServiceDeskClient } from '../../clients/service-desk.client';
import { displayJsonInNewWindow } from '../../core/utils/json-view';

const { conditionalUtils } = AmplifyCore;
const classes = styles();

class ServiceDesk extends React.Component<AppProps.ServiceDeskView, {}> {
  static defaultProps = {
    viewType: 'GRID_WIDGET_WORKLIST_SETTINGS'
  };

  componentDidMount(): void {
    const onWorkItemSelectHandler = (workitem: any, worklistContext: any) => {
      this.props.openAmplifyCase({
        serviceLine: workitem.service,
        caseId: workitem.cmx_case_uid,
        processId: workitem.cmx_process_id,
        workitemId: workitem.case_id,
        servicedeskMode: true,
        worklistContext,
        isCodingQuality: worklistContext?.isCodingQuality,
        isQualityAssessment: worklistContext?.isQualityAssessment,
        hasAmplifyCaseRunV2Access: this.props.hasAmplifyCaseRunV2Access,
        qaCollectionUuid: workitem.qa_collection_uuid
      });
    };

    const viewWorkitemDataHandler = (workitem: any) => {
      displayJsonInNewWindow(workitem);
    };

    const { capabilities } = this.props;
    // CDMX-15947 — in worklist V2 the SDK renders a header-slot placeholder in
    // place of the ProductivityTracker; dashboard-ui portals the coder "My Work"
    // top section into it. V1 / non-V2 keep the ProductivityTracker.
    const coderViewV2 = (this.props as any).coderViewV2;

    const widgetOptions = {
      onWorkItemSelected: onWorkItemSelectHandler,
      coderViewV2,
      prodTrackerActive: conditionalUtils.capabilityValue(
        capabilities?.capabilities.productivityTracker?.on
      ),
      childRef: this.props?.childRef,
      userContext: this.props?.userContext,
      viewWorkitemData: viewWorkitemDataHandler
    };

    const xcaliberClient = getServiceDeskClient();
    xcaliberClient.create(this.props.viewType, 'service_desk', widgetOptions);
  }
  render(): React.ReactNode {
    return (
      <div style={classes.root}>
        {/* @ts-ignore */}
        <Box css={styleOverrides} id="service_desk"></Box>
      </div>
    );
  }
}

export { ServiceDesk };
